import React, { useCallback, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { AnimatePresence, motion } from "framer-motion";
import classNames from "classnames";
import MenuCtaNav from "../header/menu-cta-nav";
import DashedBorder from "./dashed-border";
import ChevronDown from "@default/assets/ui/chevron-down-black.svg";
import ErrorBoundary from "../error-boundary";
import SupportersMarquee from "./supporters/supporters-marquee";
import { useWindowScroll, useWindowSize, useScrolling } from "react-use";

const BottomMenu = () => {
  const isMobile = useSelector((state) => state.appStore.isMobile);
  const { y } = useWindowScroll();
  const { height } = useWindowSize();
  const windowRef = useRef(typeof window !== "undefined" ? window : null);
  const isScrolling = useScrolling(windowRef);
  const [scrollingToTop, setScrollingToTop] = useState(false);

  const isConferenceOverviewPage = useSelector(
    (reduxStore) => reduxStore.appStore.isConferenceOverviewPage
  );
  const isFestivalOverviewPage = useSelector(
    (reduxStore) => reduxStore.appStore.isFestivalOverviewPage
  );

  const showSponsors = isConferenceOverviewPage || isFestivalOverviewPage;

  const isScrollingToTop = scrollingToTop && y > 2;
  const visible =
    isScrollingToTop || y >= height * 2 || (showSponsors && y > height * 0.3);

  const handleScrollToTop = () => {
    setScrollingToTop(true);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div
      className={classNames("bottom-menu-wrapper", {
        "is-scrolling": isScrolling,
      })}
    >
      <AnimatePresence>
        {visible && (
          <>
            <motion.div
              className="bottom-menu"
              key="bottom-menu"
              initial={{ y: "110%", opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              exit={{ y: "110%", opacity: 0 }}
            >
              <button
                type="button"
                className="to-top navigation-element"
                aria-label="Scroll to top of page"
                onClick={handleScrollToTop}
              >
                <DashedBorder blurredBackdrop reverse />
                <ChevronDown className="icon" />
              </button>
              {isMobile && <MenuCtaNav />}
            </motion.div>
            <ErrorBoundary>
              <SupportersMarquee />
            </ErrorBoundary>
          </>
        )}
      </AnimatePresence>
    </div>
  );
};

export default BottomMenu;
